import { useAuth } from "../lib/auth-context";
import { Navigate, useLocation } from "react-router-dom";

export function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading)
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="size-12 rounded-full border-4 border-slate-200 border-t-[#0066FF] animate-spin" />
            </div>
        );
    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
    if (role && user.role !== role) {
        // Redirect to their default home
        const home = user.role === "admin" ? "/admin" : user.role === "business" ? "/business" : "/consumer";
        return <Navigate to={home} replace />;
    }
    return children;
}
